<template>
    <div class="header__logo">
        <router-link to="/" class="site-logo">
        <img :src="logoSrc" alt="Logo">
        </router-link>
    </div>
  </template>
  
  <script>

  export default {
    setup() {
      return {
        logoSrc: require('@/assets/images/logo.png')
      };
    }
  };
  </script>
  
  <style scoped>

</style>
  